import React, { useState, useEffect, useContext } from "react";

import { Container } from "react-bootstrap";
import {
  PrivacyPolicy,
  SellerPrivacyPolicy,
  TermsAndCondition,
} from "../../utils/apis/master/Master";
import { Context } from "../../utils/context";

const Seller_policy = () => {
  var HtmlToReactParser = require("html-to-react").Parser;
  var htmlToReactParser = new HtmlToReactParser();
  const [getBanner, setBanner] = useState();
  const { getData, IMG_URL } = useContext(Context);
  const getProject = async () => {
    const res = await SellerPrivacyPolicy();
    if (res?.success) {
      setBanner(res?.data);
    } else {
      console.error("Error fetching  data:", res?.error);
    }
  };
  useEffect(() => {
    getProject();
    window.scrollTo(0, 0); // Scroll to the top when component mounts
  }, []);

  return (
    <>
      <section className="TermsCondition">
        <Container>
          <div className="heading-holder">
            <h1>Seller Policy</h1>
          </div>

          <div className="list-holder">
            {htmlToReactParser.parse(getBanner?.name)}{" "}
          </div>
        </Container>
      </section>
    </>
  );
};

export default Seller_policy;
